var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLiveChat(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 29,
    height: 29,
    viewBox: "0 0 29 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27 1H2C1.44772 1 1 1.44772 1 2V16.75C1 17.3023 1.44772 17.75 2 17.75H5.09378C5.63188 17.75 6.091 18.1393 6.17898 18.6702L5.19243 18.8337C5.18444 18.7854 5.1427 18.75 5.09378 18.75H2C0.89543 18.75 0 17.8546 0 16.75V2C0 0.895431 0.895431 0 2 0H27C28.1046 0 29 0.895431 29 2V16.75C29 17.8546 28.1046 18.75 27 18.75H11.4399C11.4101 18.75 11.3819 18.7633 11.3629 18.7862L6.91342 24.1562C6.63997 24.4862 6.10521 24.3418 6.03514 23.9189L5.19243 18.8337L6.17898 18.6702L6.84254 22.6744L10.5928 18.1482C10.8018 17.896 11.1123 17.75 11.4399 17.75H27C27.5523 17.75 28 17.3023 28 16.75V2C28 1.44771 27.5523 1 27 1Z",
    fill: "#2D2943"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLiveChat);
export default __webpack_public_path__ + "static/media/live-chat.81203dcf.svg";
export { ForwardRef as ReactComponent };